import { render } from "./reCaptcha.vue?vue&type=template&id=685bc1de"
import script from "./reCaptcha.vue?vue&type=script&lang=js"
export * from "./reCaptcha.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__